import { useEffect, useState } from 'react';
import { useAuth } from './useAuth';
import { useIdleTimer } from 'react-idle-timer';

export const useExpiredSession = () => {
	const [activeSession, setActiveSession] = useState<boolean | null>(null);
	const [modalIsOpen, setModalIsOpen] = useState<boolean>(false);

	const timeExpiredSession = Number(import.meta.env.VITE_TIME_EXPIRED_SESSION);

	const { isAuthenticated } = useAuth();

	const handleHasActiveUser = () => {
		if (isAuthenticated) {
			setActiveSession(true);
			setModalIsOpen(false);
		}
	};

	const handleHasIdleUser = () => {
		pause();
		setActiveSession(false);
		setModalIsOpen(true);
	};

	const { resume, pause, start } = useIdleTimer({
		onIdle: handleHasIdleUser,
		onAction: handleHasActiveUser,
		timeout: timeExpiredSession,
		startManually: true,
		throttle: 500,
	});

	const handleCloseModalExpiredSession = () => {
		if (isAuthenticated) {
			resume();
			setActiveSession(true);
		} else {
			setActiveSession(null);
		}
		setModalIsOpen(false);
	};

	const handleLogout = () => {
		pause();
		setActiveSession(null);
	};

	useEffect(() => {
		if (isAuthenticated) {
			start();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isAuthenticated]);

	return {
		activeSession,
		modalIsOpen,
		handleCloseModalExpiredSession,
		handleLogout,
	};
};
